export type CpmSubmissionApproval = {
  admin_approval?: string | null;
};

/**
 * Disapproved submissions are never final (an admin can re-review and flip
 * them later — see backend adminReviewCpmCampaignSubmission), so this only
 * hides them from the clipper's own view; it never deletes or mutates data.
 */
export function filterVisibleSubmissions<T extends CpmSubmissionApproval>(
  submissions: T[],
  { hideDisapproved }: { hideDisapproved: boolean },
): T[] {
  if (!hideDisapproved) return submissions;
  return submissions.filter((s) => s.admin_approval !== 'disapproved');
}

export function countDisapprovedSubmissions(submissions: CpmSubmissionApproval[]): number {
  return submissions.filter((s) => s.admin_approval === 'disapproved').length;
}
